import React from 'react';
import styled from 'styled-components';
import { display, height, space, width } from 'styled-system';

export default function Divider(props) {
  return <StyledDivider {...props} />;
}

/* eslint-disable i18next/no-literal-string */
const StyledDivider = styled.span`
  border-top: ${({ color, theme }) => `1px solid ${color || theme.colors.blueGrey[95]}`};
  height: 1px;
  max-width: 100%;
  ${display}
  ${height}
  ${space}
  ${width}
`;

StyledDivider.defaultProps = { display: 'block' };
